export const paymentConfig = {
  paymentConfig: "Approve Topup",
  depositAccount: "Deposit Account",
  withdrawAccount: "Withdraw Account",
  save: "Save",
  cancel: "Cancel",
  disableWithdraw: "Disable Withdraw",
  disableDeposit: "Disable Deposit",
  deposit:"Deposit",
  withdraw:"Withdraw",
  open: "Open",
  close: "Close",
};
